export  const INPUT_REG_EXP = {
    EMAIL : /^([\w\_])*[a-zA-Z0-9]*([\w\.\_\-])*([a-zA-Z0-9])+([\w\_])*@([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,8}$/g,
    TEAM_URL : /^[0-9a-zA-Z\-]{3,50}$/,
    EMOJI : /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD10-\uDDFF])/ig,
    DOMAIN : /^[0-9a-z_+]*$/g,
    NUMBER : /^[0-9]+$/,
    PASSWORD : /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*\-_+=,./?:;'"{<>()\[}\]\\|])[A-Za-z\d`~!@#$%^&*\-_+=,./?:;'"{<>()\[}\]\\|]{8,20}$/g,
    LOGIN_PASSWORD : /^.{1,20}$/g,
    MORE_THAN_EIGHT : /^.*(?=^.{8,20}$)(?=.*\d)(?=.*[a-zA-Z]).*$/g,
    NAME_SPECIAL : /[#<>\[\]]/,
    UPPER_CASE : /[A-Z]/g,
}

export const VALID_CODE = {
    EMPTY : "empty",
    OVER : "over",
    UNDER: "under",
    INVALID : "un-valid",
    INVALID_LETTER_CASE : 'in-valid-letter-case'
}